import { enumeration } from '@dazn/peng-html5-tools-utils';
/**
 * A map between severity and numeric message type.
 */
var MessageType = enumeration({
    INFO: 0,
    LOG: 1,
    WARNING: 2,
    ERROR: 3,
});
export { MessageType };
//# sourceMappingURL=MessageType.js.map